import { MaskLines, Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, image, imageAlt, children, testid, caption = "Symbolbild" }) => (
  <section className="relative overflow-hidden bg-white pt-[120px] md:pt-[150px] pb-16 md:pb-24" data-testid={testid}>
    <div className="absolute inset-0 grid-lines pointer-events-none" aria-hidden="true" />
    <div className="container-x relative grid gap-12 lg:grid-cols-12 lg:items-end">
      <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
        <Reveal y={12}><p className="eyebrow">{eyebrow}</p></Reveal>
        <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-[color:var(--navy)]">
          <MaskLines lines={lines} />
        </h1>
        {intro && <Reveal delay={0.35}><p className="mt-7 max-w-2xl text-base md:text-lg leading-relaxed text-slate-600">{intro}</p></Reveal>}
        {children && <Reveal delay={0.45} className="mt-9">{children}</Reveal>}
      </div>
      {image && (
        <Reveal delay={0.25} className="lg:col-span-5">
          <figure className="relative aspect-[4/3] lg:aspect-[4/5] overflow-hidden rounded-[2rem] rounded-tr-[6rem] bg-slate-100">
            <img src={image} alt={imageAlt} className="h-full w-full object-cover" loading="eager" />
            <figcaption className="absolute bottom-3 left-3 rounded-full bg-white/85 px-3 py-1 text-[11px] font-medium text-slate-700 backdrop-blur">{caption}</figcaption>
          </figure>
        </Reveal>
      )}
    </div>
  </section>
);
